import { apiRequest, queryString } from "./http";
import type {
  ApiListParams,
  CommentRecord,
  CreateCommentPayload,
} from "./generated/openapi";

export const commentApi = {
  listForProject: (
    projectId: string | number,
    params: ApiListParams = {},
  ) =>
    apiRequest<CommentRecord[]>(
      `/api/projects/${projectId}/comments${queryString(params)}`,
    ),

  createForProject: (projectId: string | number, payload: CreateCommentPayload) =>
    apiRequest<CommentRecord>(`/api/projects/${projectId}/comments`, {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  delete: (id: string | number) =>
    apiRequest<CommentRecord>(`/api/comments/${id}`, { method: "DELETE" }),
};
